import React from "react";
import {
  styled,
  OutlinedInput,
  StandardTextFieldProps,
  InputAdornment,
  TextField,
  Stack,
  IconButton
} from "@mui/material";
import SelectInput from "./SelectInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme: any) => ({
  styledDatePicker: {
    "& .react-datepicker__triangle": {
      left: "-50px !important",
      "&::after": {
        borderBottomColor: `${theme.palette.common.white} !important`
      }
    },
    "& .react-datepicker__header": {
      backgroundColor: `${theme.palette.common.white} !important`,
      borderBottom: 0
    }
  }
}));

const CustomTextField = styled(OutlinedInput)(() => ({
  border: "none",
  padding: 0,
  "& .MuiOutlinedInput-notchedOutline": {
    display: "none"
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
    fontWeight: 400
  },
  "& .MuiIconButton-root": {
    width: 54
  }
}));
export interface SearchFieldWithFiltersInterface
  extends StandardTextFieldProps {
  placeholder?: string;
  height?: number;
  width?: number;
  type?: string;
  categoryOptions?: { label: string; value: string }[];
  typeOptions?: { label: string; value: string }[];
  onDateSelect?: (date: any) => void;
  onCategorySelect?: (value: string) => void;
  onTypeSelect?: (value: string) => void;
  selectedType?: string;
  selectedCategory?: string;
  selectedDate?: any;
}

const StyledTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== "height",
  name: "TextField"
})<{ height?: number }>(({ height, theme }) => ({
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  height: height || 50,
  "& .MuiInput-root": {
    height: "100%",
    fontSize: 16
  },
  "& .MuiInputAdornment-root": {
    color: theme.palette.common.white,
    justifyContent: "center",
    height: "100%",
    maxHeight: "100%",
    borderRadius: "0px 15px 15px 0px",
    "& .far": {
      textAlign: "center"
    }
  }
}));

const SearchIcon = styled(Stack)(({ theme }) => ({
  background: theme.palette.primary.main,
  width: 56,
  justifyContent: "center",
  height: "100%",
  maxHeight: "100%",
  borderRadius: "0px 15px 15px 0px"
}));

const FilterContainer = styled(Stack)(({ theme }: any) => ({
  width: 155,
  borderLeft: `1px solid ${theme.palette.common.borderGrey}`,
  height: "100%"
}));

const SearchFieldWithFilters = ({
  placeholder = "Search",
  height = 50,
  type,
  categoryOptions,
  typeOptions,
  onDateSelect,
  onCategorySelect,
  onTypeSelect,
  selectedType,
  selectedCategory,
  selectedDate,
  ...props
}: SearchFieldWithFiltersInterface) => {
  const classes = useStyles({});
  const EndAdornment = () => {
    const ExampleCustomInput = (
      <CustomTextField
        label="Date"
        placeholder="Date"
        value={selectedDate}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" edge="end">
              <i
                className="far fa-angle-down"
                style={{ fontSize: "0.75rem", fontWeight: 700 }}
              />
            </IconButton>
          </InputAdornment>
        }
      />
    );

    return (
      <Stack direction="row" height="100%">
        {type && type === "date"
          ? <FilterContainer>
              <DatePicker
                wrapperClassName={classes.styledDatePicker}
                calendarClassName={classes.styledDatePicker}
                selected={selectedDate}
                placeholderText="Date"
                onChange={(date: any) => {
                  if (onDateSelect) onDateSelect(date);
                }}
                customInput={ExampleCustomInput}
              />
            </FilterContainer>
          : null}
        {categoryOptions &&
          <FilterContainer>
            <SelectInput
              value={selectedCategory}
              placeholder="Category"
              options={categoryOptions}
              roundedCorners={false}
              onChange={(e: any) => {
                if (onCategorySelect) onCategorySelect(e.target.value);
              }}
              fontSize={16}
            />
          </FilterContainer>}
        {typeOptions &&
          <FilterContainer>
            <SelectInput
              value={selectedType}
              placeholder="Type"
              options={typeOptions}
              roundedCorners={false}
              onChange={(e: any) => {
                if (onTypeSelect) onTypeSelect(e.target.value);
              }}
              fontSize={16}
            />
          </FilterContainer>}
        <SearchIcon>
          <i className="far fa-search" />
        </SearchIcon>
      </Stack>
    );
  };
  return (
    <StyledTextField
      {...props}
      height={height}
      variant="standard"
      placeholder={placeholder}
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            <EndAdornment />
          </InputAdornment>
        ),
        autoComplete: "off"
      }}
    />
  );
};

export default SearchFieldWithFilters;
